import { PaymentProviderType } from "@redotech/redo-model/billing/billing-engine-types";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getPreferredPaymentProvider = {
  name: "getPreferredPaymentProvider" as const,
  input: z.object({}),
  output: createEnum(PaymentProviderType),
};
